import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import axios from 'axios';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
import constants from '../../constants';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');


const BookingFilter = (props) => {
  const typeahead = useRef();
  const cityTypeHead = useRef();
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [hotelList, setHotelList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    getCountrList();
    // eslint-disable-next-line
  }, []);

  const dateChangeRaw = (e) => {
    e.preventDefault();
  };

  const handleSearch = (hotel) => {
    if (typeof hotel === 'undefined' || hotel === '') {
      return;
    }
    if (hotel.length > 2) {
      getHotelList(hotel);
    }
  };

  const getHotelList = (hotel) => {
    setShowSearchLoader(true);
    axios(serverUrl + 'property/gethotellisting', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param: { page: 1, limit: 10, hotelName: hotel } }
    }).then(response => {
      if (response.data.status === 'success') {
        setHotelList(response.data.data.list);
      } else {
        // Optionally show error
      }
      setShowSearchLoader(false);
    }).catch(error => {
      console.log(error);
      setShowSearchLoader(false);
    });
  };

  const getCountrList = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId') || 1;
    axios(serverUrl + 'common/masterlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId }
    }).then(response => {
      setCountryList(response.data.countryList);
    }).catch(error => {
      console.log(error);
      setShowSearchLoader(false);
    });
  };

  const handleSearchCity = (cityname) => {
    if (typeof cityname === 'undefined' || cityname === '') {
      return;
    }
    if (props.params.countryId === 0) {
      alert('Please select country first.');
      return;
    }
    if (cityname.length > 2) {
      getCityList(cityname);
    }
  };

  const getCityList = (cityName) => {
    if (props.countryId !== '') {
      setShowSearchLoader(true);
      axios(serverUrl + 'common/cityList', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { cityName: cityName, countryId: props.params.countryId }
      })
        .then(response => {
          if (response.data.status === 'success') {
            setCityList(response.data.data.cityList);
          } else {
            alert(response.data.message);
            return;
          }
          setShowSearchLoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowSearchLoader(false);
        });
    }
  };

  const reset = () => {
    if (typeahead.current && typeahead.current.getInstance) typeahead.current.getInstance().clear();
    if (cityTypeHead.current && cityTypeHead.current.getInstance) cityTypeHead.current.getInstance().clear();
    props.reset();
  };

  return (
    <div className="container_fluid pad_lft_rht25 padtop10 bg2_12 boder_b_1 border_color_1">
      <div className="row gutters-5">
        {/* ...existing code... */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={props.params.channelId}
              onChange={e => props.paramChange(e, 'channelId')}
            >
              <option value="0">OTA</option>
              {Object.keys(props.ota).length > 0
                ? Object.keys(props.ota).map(id => {
                  var data = props.ota[id];
                  return (
                    <option value={data.channel_id} key={id}>
                      {data.ota_name}
                    </option>
                  );
                })
                : ''}
            </select>
          </div>
        </div>
        {/* ...existing code for other filters, replace class methods with hooks and props... */}
        {/* category mapped or not  */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            {' '}
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={props.params.categoryMapStatus}
              onChange={e => props.paramChange(e, 'categoryMapStatus')}
            >
              <option value="">All</option>
              <option value="0">Category Not Mapped</option>
              <option value="1">Category Mapped</option>
            </select>
          </div>
        </div>
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            {' '}
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={props.params.hotelMapStatus}
              onChange={e => props.paramChange(e, 'hotelMapStatus')}
            >
              <option value="">All</option>
              <option value="0">Hotel Not Mapped</option>
              <option value="1">Hotel Mapped</option>
            </select>
          </div>
        </div>
        {/* booking Status */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            {' '}
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={props.params.bookingStatus}
              onChange={e => props.paramChange(e, 'bookingStatus')}
            >
              <option value="">Select Booking Status</option>
              <option value="new">New</option>
              <option value="modify">Modify</option>
              <option value="cancel">Cancel</option>
            </select>
          </div>
        </div>

        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            {' '}
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={props.params.countryId}
              onChange={e => props.paramChange(e, 'countryId')}
            >
              <option value="">Select Country</option>
              {Object.keys(countryList).map((id, i) => {
                return (
                  <option key={i} value={countryList[id].country_id}>
                    {countryList[id].country}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <AsyncTypeahead
              ref={cityTypeHead}
              inputProps={{ className: 'inputs' }}
              multiple={false}
              id="city"
              isLoading={showSearchLoader}
              options={cityList}
              labelKey="city"
              minLength={3}
              align="justify"
              onSearch={handleSearchCity}
              placeholder={'City'}
              filterBy={['city']}
              selectHintOnEnter
              onChange={selected => {
                props.handleAsyncCity(selected, 'cityName');
              }}
              renderMenuItemChildren={(option, props) => (
                <span key={option.city_id} id={option.city_id}>
                  {option.state ? option.city + ' ,' + option.state : option.city}
                </span>
              )}
            />
          </div>
        </div>

        <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              <input
                type="text"
                placeholder="Booking ID"
                className="input pad_lft_rht5"
                value={props.params.bookingId}
                onChange={e => props.paramChange(e, 'bookingId')}
              />
            </div>
          </div>

          <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              {' '}
              <span className="ficon pad_lft_rht10">
                <i className="fa fa-calendar"></i>
              </span>
              <DatePicker
                inputProps={{ disabled: true }}
                placeholderText="Check In from"
                dateFormat="yyyy-MM-dd"
                className="input pad_lft_rht5"
                name="check_in"
                onChangeRaw={e => dateChangeRaw(e)}
                onChange={e => props.dateChange(e, 'checkIn')}
                selected={props.params.checkIn !== '' ? new Date(props.params.checkIn) : null}
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              {' '}
              <span className="ficon pad_lft_rht10">
                <i className="fa fa-calendar"></i>
              </span>
              <DatePicker
                inputProps={{ disabled: true }}
                placeholderText="Check In to"
                dateFormat="yyyy-MM-dd"
                className="input pad_lft_rht5"
                name="check_in_to"
                onChangeRaw={e => dateChangeRaw(e)}
                onChange={e => props.dateChange(e, 'checkInTo')}
                selected={props.params.checkInTo !== '' ? new Date(props.params.checkInTo) : null}
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              {' '}
              <span className="ficon pad_lft_rht10">
                <i className="fa fa-calendar"></i>
              </span>
              <DatePicker
                inputProps={{ disabled: true }}
                placeholderText="Check Out from"
                dateFormat="yyyy-MM-dd"
                className="input pad_lft_rht5"
                name="check_out"
                onChangeRaw={e => dateChangeRaw(e)}
                onChange={e => props.dateChange(e, 'checkOut')}
                selected={props.params.checkOut !== '' ? new Date(props.params.checkOut) : null}
              />
            </div>
          </div>

          <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              {' '}
              <span className="ficon pad_lft_rht10">
                <i className="fa fa-calendar"></i>
              </span>
              <DatePicker
                inputProps={{ disabled: true }}
                placeholderText="Check Out to"
                dateFormat="yyyy-MM-dd"
                className="input pad_lft_rht5"
                name="check_out_to"
                onChangeRaw={e => dateChangeRaw(e)}
                onChange={e => props.dateChange(e, 'checkOutTo')}
                selected={props.params.checkOutTo !== '' ? new Date(props.params.checkOutTo) : null}
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              {' '}
              <span className="ficon pad_lft_rht10">
                <i className="fa fa-calendar"></i>
              </span>
              <DatePicker
                inputProps={{ disabled: true }}
                placeholderText="Booking Date from"
                dateFormat="yyyy-MM-dd"
                className="input pad_lft_rht5"
                name="travel_date"
                onChangeRaw={e => dateChangeRaw(e)}
                onChange={e => props.dateChange(e, 'bookingDate')}
                selected={props.params.bookingDate !== '' ? new Date(props.params.bookingDate) : null}
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              {' '}
              <span className="ficon pad_lft_rht10">
                <i className="fa fa-calendar"></i>
              </span>
              <DatePicker
                inputProps={{ disabled: true }}
                placeholderText="Booking Date to"
                dateFormat="yyyy-MM-dd"
                className="input pad_lft_rht5"
                name="travel_date_to"
                onChangeRaw={e => dateChangeRaw(e)}
                onChange={e => props.dateChange(e, 'bookingDateTo')}
                selected={props.params.bookingDateTo !== '' ? new Date(props.params.bookingDateTo) : null}
              />
            </div>
          </div>
        {/* ...existing code for other filters... */}
        <div className="col-xs-12 col-md-2 marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <AsyncTypeahead
              ref={typeahead}
              inputProps={{ className: 'inputs' }}
              multiple={false}
              isLoading={showSearchLoader}
              options={hotelList}
              id={'hotel'}
              labelKey={'hotel'}
              minLength={3}
              align="justify"
              onSearch={handleSearch}
              placeholder={'Hotel'}
              filterBy={['hotel','hotel_code']}
              selectHintOnEnter
              onChange={selected => {
                props.paramChange(selected, 'hotelName');
              }}
              renderMenuItemChildren={(option, props) => (
                <span key={option.hotel_id} id={option.hotel_id}>
                  {option.hotel}
                </span>
              )}
            />
          </div>
        </div>
        {/* ...existing code for other filters and buttons... */}
        <div className="col-xs-12 col-md-auto marg_bottom10">
          <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={() => props.searchBooking()}>
            <i className="fa fa-filter marg_right7"></i>Filter
          </div>
        </div>
        <div className="col-xs-12 col-md-auto marg_bottom10">
          <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={reset}>
            <i className="fa fa-repeat marg_right7"></i>Reset
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingFilter;